<template>
  <div class="form-control-draggable">
    <table class="form-control-draggable__table">
      <thead v-show="items.length">
        <tr>
          <th v-for="(cell, key) in schemeShowcase" :key="key">
            {{ cell.label }}
          </th>
          <th></th>
        </tr>
      </thead>
      <draggable v-model="items" v-bind="dragOptions" tag="tbody">
        <tr
          v-for="(item, index) in items"
          :key="index"
          class="form-control-draggable__item"
        >
          <td v-for="(cell, key) in schemeShowcase" :key="key">
            <el-image
              v-if="cell.format === 'image'"
              :src="`${mediaUrl}${item[cell.name]}`"
              :preview-src-list="[`${mediaUrl}${item[cell.name]}`]"
              fit="contain"
              lazy
              style="width: 100px; height: 60px"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
            <i
              v-else-if="cell.format === 'boolean' && item[cell.name] === true"
              class="el-icon el-icon-success"
            />
            <i
              v-else-if="cell.format === 'boolean' && item[cell.name] === false"
              class="el-icon el-icon-error"
            />
            <span v-else>{{ item[cell.name] }}</span>
          </td>
          <td>
            <el-tooltip content="Редактировать" placement="top">
              <el-button
                icon="el-icon-edit"
                plain
                size="mini"
                @click="onUpdate(item, index)"
              />
            </el-tooltip>
            <el-tooltip content="Удалить" placement="top">
              <el-button
                type="danger"
                icon="el-icon-close"
                plain
                size="mini"
                @click="onRemove(index)"
              />
            </el-tooltip>
          </td>
        </tr>
      </draggable>
    </table>
    <!-- <el-button
      v-show="items.length < maxLengthArray"
      type="primary"
      size="small"
      @click="onCreate"
      >Добавить элемент</el-button
    > -->
    <DialogForm
      v-show="items.length < maxLengthArray || dialogExistsData"
      :visible="dialogVisible"
      :scheme="scheme"
      :existsData="dialogExistsData"
      @close="onClose"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";

import DialogForm from "@/components/DialogForm";
import defaultSettings from "@/settings";

const { baseApi } = defaultSettings;

export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    maxLengthArray: {
      type: Number,
      required: false,
      default: Infinity,
    },
    scheme: {
      type: Array,
      required: true,
    },
  },
  components: {
    draggable,
    DialogForm,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        ghostClass: "form-control-draggable__move",
      };
    },
    mediaUrl() {
      return baseApi;
    },
    items: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    schemeShowcase() {
      return this.scheme.filter((e) => e.showcase);
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogExistsData: null,
    };
  },
  methods: {
    onCreate() {
      this.dialogVisible = true;
      this.dialogExistsData = null;
    },
    onUpdate(data, index) {
      this.dialogVisible = true;
      this.dialogExistsData = { id: index, data: Object.assign({}, data) };
    },
    onRemove(index) {
      this.items.splice(index, 1);
      this.$emit("input", this.items);
    },
    onClose() {
      // this.dialogVisible = false;
      this.dialogExistsData = null;
    },
    onSubmit({ id, data }) {
      const isEdit = id !== null;

      if (isEdit) {
        this.items.splice(id, 1, data);
      } else {
        this.items.push(data);
      }
      this.$emit("input", this.items);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.form-control-draggable {
  &__move {
    opacity: 0.5;
  }
  &__table {
    width: 100%;
    border-collapse: collapse;
    tr {
      padding: 0;
      margin: 0;
      th,
      td {
        text-align: left;
        .el-image {
          display: block;
        }
      }
      th:last-child,
      td:last-child {
        text-align: right;
      }
      th {
        font-size: 14px;
        color: #606266;
        line-height: 20px;
        padding: 10px 0;
      }
      td {
        border-top: 1px solid #eee;
        padding: 5px 0;
      }
    }
  }
  &__item {
    cursor: move;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  .el-icon-success {
    color: #67c23a;
  }
  .el-icon-error {
    color: #ee2d24;
  }
}
</style>
